// ─── App ──────────────────────────────────────────────────────────
export const APP_NAME = import.meta.env.VITE_APP_NAME ?? "Synkd";
export const APP_VERSION = import.meta.env.VITE_APP_VERSION ?? "1.0.0";

// ─── Pagination ───────────────────────────────────────────────────
export const DEFAULT_PAGE_SIZE = 20;
export const MAX_PAGE_SIZE = 100;

// ─── Cache / polling ─────────────────────────────────────────────
/** Poll live events every 30 s */
export const LIVE_POLL_INTERVAL_MS = 30_000;
/** Stale-while-revalidate threshold */
export const CACHE_STALE_MS = 5 * 60 * 1000; // 5 min

// ─── Local storage keys (namespace to avoid collisions) ───────────
export const STORAGE_KEYS = {
  AUTH_TOKEN: "fd:auth_token",
  REFRESH_TOKEN: "fd:refresh_token",
  REDUX_PERSIST: "fd:redux",
  THEME: "fd:theme",
} as const;

// ─── Route paths (single source of truth) ─────────────────────────
export const ROUTES = {
  // Auth
  LOGIN: "/auth/login",
  REGISTER: "/auth/register",
  FORGOT_PASSWORD: "/auth/forgot-password",
  LEAGUE_ONBOARDING: "/league-onboarding",

  // ── Home section
  DASHBOARD: "/home",
  CALENDAR: "/calendar",
  MEMBERS: "/attendees",
    SHOP: "/content/club-shop",
    COMPANIES: "/companies",
    ANNOUNCEMENTS: "/content/club-announcements",
    POLICIES: "/content/club-policies",
  // Generic content route (optional slug)
  CONTENT_PAGE: "/content/:pageSlug?",
  TEAM: "/content/team-1",
  FIXTURES: "/content/fixtures",
  MY_ORDERS: "/orders",
  CART: "/cart",
  ORDERS_HISTORY: "/orders",
  CONTENTS: "/content/:contentId",
  PERFORMANCE_RATING: "/performance-rating",

  // ── Admin section
  TEAM_MANAGEMENT: "/admin/team-management",
  CLUSTER_MANAGEMENT: "/admin/cluster-management",
  REGISTER_REQUESTS: "/admin/register-requests",
  LEAGUE_MANAGEMENT: "/league-management",
  SQUAD_BUILDER: "/admin/squad-builder",
  INVITED: "/admin/invited",
  TRANSACTIONS: "/admin/transactions",
  REQUEST_MANAGEMENT: "/admin/request-management",
  SPACES: "/admin/spaces",
  COUPONS: "/admin/coupons",
  PRODUCTS: "/admin/products",
  SETTINGS: "/admin/settings",

  // ── Kept for compatibility
  EVENTS: "/events",
  EVENT_DETAIL: "/events/:id",
  TEAMS: "/teams",
  ANNOUCEMENTS: "/content/club-announcements",
  // SETTINGS: "/settings",
  PROFILE: "/settings/profile",
} as const;

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES];

// ─── Event statuses ───────────────────────────────────────────────
export const EVENT_STATUS_LABELS = {
  scheduled: "Scheduled",
  live: "Live",
  completed: "Completed",
  postponed: "Postponed",
  cancelled: "Cancelled",
} as const;
